import { navigateTo } from "./navigateTo";
import { registerServiceWorker } from "./registerServiceWorker";
import { clearCache } from "./clearCache";

const CLEAR_CACHE_EVERY_MINUTES = 10;
const LAST_CACHE_CLEAR_LOCALSTORAGE_KEY = "last-cache-clear";

function minutesToMilliseconds(minutes: number) {
    return 1000 * 60 * minutes;
}

function main() {
    const lastCacheClearLocalStorage = localStorage.getItem(LAST_CACHE_CLEAR_LOCALSTORAGE_KEY);
    let lastCacheClear = lastCacheClearLocalStorage ? parseInt(lastCacheClearLocalStorage, 10) : 0;
    if (!lastCacheClear) {
        if (navigator.onLine) {
            clearCache();
        }
        lastCacheClear = new Date().valueOf();
    }

    window.setInterval(() => {
        if (lastCacheClear + minutesToMilliseconds(CLEAR_CACHE_EVERY_MINUTES) < new Date().valueOf()) {
            if (navigator.onLine) {
                clearCache();
            }
            lastCacheClear = new Date().valueOf();
        }
    }, minutesToMilliseconds(CLEAR_CACHE_EVERY_MINUTES));

    window.onpopstate = (e) => navigateTo(location.pathname, e.state, false)(null);
    window.onunload = () => localStorage.setItem(LAST_CACHE_CLEAR_LOCALSTORAGE_KEY, JSON.stringify(lastCacheClear));

    navigateTo(location.pathname, null)(null);
    registerServiceWorker();
}

if (typeof fetch === "undefined" || typeof Promise === "undefined") {
    const polyfillTag = document.createElement("script");
    polyfillTag.src = '/dist/polyfills.js';
    polyfillTag.onload = () => main();
    document.head.appendChild(polyfillTag);
} else {
    main();
}
